class storage {
    getItem(key){
        let val =  localStorage.getItem(key)
        return val;
        if(!val){
            
        }

        let valLast= val.substr(val.length-1,1),valFirst=val[0]
        if((valFirst=='{' || valFirst=='[') && (valLast=='}' || valLast==']')){
            return JSON.parse(val)
        }
    }
    setItem(key,val){
        // if(typeof val == 'string' || typeof val == 'number'  )
        if(typeof val == 'object')  {
            val = JSON.stringify(val)
        }
        return localStorage.setItem(key,val)
    }
}

export default  new storage();


// WEBPACK FOOTER //
// ./src/utils/storage.js